import { untilComplete } from "@pjs/observables";
import { extendTemporaryAccess } from "../functions/ExtendTemporaryAccess.function";
import { TemporaryAccessState } from "../enums/TemporaryAccessState";
import { temporaryAccessDetails } from "../consts/TemporaryAccessDetails.const";

export const extendTemporaryAccessExpiry = (tempAccessId: string, numDays: number): void => {
    const document = temporaryAccessDetails.get();

    document.model.state.update({ descriptor: TemporaryAccessState.ExtendPending });

    extendTemporaryAccess(numDays, { tempAccessId: tempAccessId })
        .pipe(untilComplete(document.changeStream))
        .subscribe({
            next: () => {
                const currentModel = document.model.details.get();
                if (currentModel === null) {
                    return;
                }

                const expiryDate = new Date(currentModel.expiry);
                const newDate = new Date(expiryDate);
                newDate.setDate(expiryDate.getDate() + numDays);

                document.model.details.update({ expiry: newDate.toISOString() });
                document.model.state.update({ descriptor: TemporaryAccessState.ExtendSuccess });
            },
            error: () => {
                document.model.state.update({ descriptor: TemporaryAccessState.ExtendFailed });
            }
        });
};
